import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { NativeSelect } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { todayLocal } from "@/lib/format";

const BLANK = { date: "", amount: "", ref: "", note: "", proof: "", kind: "penjualan", customer_id: "", reason: "" };

export function TopupDialog({ target, period, customers, onClose, onDone }) {
  const [f, setF] = useState(BLANK);
  const edit = target?.id;
  useEffect(() => {
    if (target) setF(edit ? { ...BLANK, ...target, customer_id: target.customer_id || "", reason: "" } : { ...BLANK, date: todayLocal() });
  }, [target, edit]);
  if (!target) return null;
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    const body = { ...f, period, amount: Number(f.amount), customer_id: f.customer_id || null };
    try {
      if (edit) await api.put(`/topups/${target.id}`, body); else await api.post("/topups", body);
      toast.success(edit ? "Koreksi top up tersimpan (sebelum/sesudah tercatat)" : "Top up dicatat");
      onDone();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="topup-dialog">
        <DialogHeader>
          <DialogTitle>{edit ? "Koreksi Top Up" : "Catat Top Up"}</DialogTitle>
          <DialogDescription>Catat hanya top up yang benar-benar dilakukan ke sistem pembuatan voucher, sesuai bukti transaksi.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div><Label>Jenis</Label>
            <NativeSelect value={f.kind} onChange={set("kind")} className="w-full h-11" data-testid="topup-kind-select">
              <option value="penjualan">Top up penjualan aktual</option>
              <option value="pasokan_awal">Pembayaran pasokan awal (terpisah)</option>
            </NativeSelect>
          </div>
          {f.kind === "pasokan_awal" && (
            <div><Label>Pelanggan (opsional)</Label>
              <NativeSelect value={f.customer_id} onChange={set("customer_id")} className="w-full h-11" data-testid="topup-customer-select">
                <option value="">— umum —</option>
                {customers.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </NativeSelect>
            </div>
          )}
          <div className="grid grid-cols-2 gap-2">
            <div><Label>Tanggal</Label><Input type="date" value={f.date} onChange={set("date")} required className="h-11" data-testid="topup-date-input" /></div>
            <div><Label>Nominal (Rp)</Label><Input type="number" min={1} value={f.amount} onChange={set("amount")} required className="h-11 font-mono" data-testid="topup-amount-input" /></div>
          </div>
          <div><Label>Referensi transaksi</Label><Input value={f.ref} onChange={set("ref")} required className="h-11" data-testid="topup-ref-input" /></div>
          <div><Label>Bukti (no. struk / tautan, opsional)</Label><Input value={f.proof} onChange={set("proof")} className="h-11" data-testid="topup-proof-input" /></div>
          <div><Label>Keterangan</Label><Input value={f.note} onChange={set("note")} className="h-11" data-testid="topup-note-input" /></div>
          {edit && <div><Label>Alasan koreksi (wajib)</Label><Textarea rows={2} value={f.reason} onChange={set("reason")} data-testid="topup-reason-input" /></div>}
          <DialogFooter><Button type="submit" disabled={edit && f.reason.trim().length < 5} className="h-11 bg-emerald-700 hover:bg-emerald-800" data-testid="topup-submit-btn">Simpan</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
